import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NavigationItem } from '@fc-core/navbar/navigation/navigation-item';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'fc-navigation-children',
  template: `
    <a
      class="flex items-center cursor-pointer hover:bg-primary-950
          hover:text-secondary-50
         rounded-4 py-8 px-12 rounded-lg transition-all text-base
         duration-150 text-nowrap text-secondary-200 leading-[24px]"
      [routerLink]="child().link"
      routerLinkActive="bg-primary-900 text-secondary-50!"
      (click)="click.emit()"
    >
      {{ child().name }}
    </a>
  `,
  imports: [RouterModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationChildrenComponent {
  child = input<NavigationItem>();
  click = output();
}
